import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'effectivenessReviewAttributes',
    'effectivenessReviewAttributesCheckBox',
    'endPageAttributes',
    'recommendationCheckBox',
  ];

  connect() {
    this.toggleEndPageFields();
    this.toggleEffectivenessReviewAttributes();
  }

  toggleEndPageFields() {
    const checkbox =
      this.hasRecommendationCheckBoxTarget &&
      this.recommendationCheckBoxTarget.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    this.endPageAttributesTarget.hidden = checkbox.checked;
  }

  toggleEffectivenessReviewAttributes() {
    const checkbox =
      this.hasEffectivenessReviewAttributesCheckBoxTarget &&
      this.effectivenessReviewAttributesCheckBoxTarget.querySelector(
        'input[type="checkbox"]',
      );
    if (!checkbox) return;

    this.effectivenessReviewAttributesTarget.hidden = !checkbox.checked;
  }
}
